import React from 'react'
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '../../common/Card'

const styles = theme => ({
  leftCard: {
    marginLeft: '120px',
    backgroundColor: 'blue'
  },
  campoNome: {
    fontSize: '1rem'
  },
  campoValor: {
    fontSize: '1.3rem'
  },

});

export default ({ brand, model, size, marcaFogo, dot, vida, banda, itemBandaAplicada }) => (
  <React.Fragment>
    <Card isCustomStyle  classes={{
      paper: styles.leftCard,
      root: styles.leftCard
    }}  >
      <Typography variant="subtitle1" style={{textAlign:"center", fontSize: '1.5rem'}}>PNEU</Typography>
      <List>
        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
          <Typography style={{ fontSize: '0.8rem'}}>MARCA:</Typography>
          <Typography style={{ fontSize: '1.3rem'}}>{brand}</Typography>
        </ListItem>
        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
          <Typography style={{ fontSize: '0.8rem'}}>MODELO:</Typography>
          <Typography style={{ fontSize: '1.3rem'}}>{model}</Typography>
        </ListItem>
        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
          <Typography style={{ fontSize: '0.8rem'}}>TAMANHO:</Typography>
          <Typography style={{ fontSize: '1.3rem'}}>{size}</Typography>
        </ListItem>
        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
          <Typography style={{ fontSize: '0.8rem'}}>MARCA FOGO:</Typography>
          <Typography style={{ fontSize: '1.3rem'}}>{marcaFogo}</Typography>
        </ListItem>
        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
          <Typography  style={{ fontSize: '0.8rem'}}>DOT:</Typography>
          <Typography style={{ fontSize: '1.3rem'}}>{dot}</Typography>
        </ListItem>
        {/*<ListItem style={{display:'flex', justifyContent:'space-between'}}>*/}
        {/*  <Typography  style={{ fontSize: '0.8rem'}}>VIDA:</Typography>*/}
        {/*  <Typography style={{ fontSize: '1.3rem'}}>{vida}</Typography>*/}
        {/*</ListItem>*/}
        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
          <Typography  style={{ fontSize: '0.8rem'}}>BANDA SOLICITADA:</Typography>
          <Typography style={{ fontSize: '1.3rem'}}>{banda}</Typography>
        </ListItem>
        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
          <Typography  style={{ fontSize: '0.8rem'}}>ITEM APLICADO:</Typography>
          <Typography style={{ fontSize: '1.3rem'}}>{itemBandaAplicada}</Typography>
        </ListItem>
      </List>
    </Card>
  </React.Fragment>
);
